import React, { createContext, useEffect, useContext, useState } from "react";
import axiosInstance from "../Config/axios";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Loader from "../Components/Loader/Loader";

export const BookSessionContext = createContext();


export const useBookSession = () => useContext(BookSessionContext);


export const BookSessionProvider = ({ children, user }) => {
  const [loading, setLoading] = useState(false);
  const [ confirmData, setConfirmData ] = useState(null);
  const navigate = useNavigate();
  const time_Zone = Intl.DateTimeFormat().resolvedOptions().timeZone;


  const fetchLocationData = async () => {
    const token = localStorage.getItem("accessToken");

    if(!token){
      navigate("/login");
      return;
    }
    
    
    try {
      const response = await axiosInstance.get(`/adminpanel/locations/`, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
              
              timezone: time_Zone,   
            }
      });
      
      return response.data;

    } catch (err) {
      // Swal.fire({
      //   icon: "error",
      //   title: "Error",
      //   text: err.response?.data?.detail || "Failed to fetch location details.",
      //   confirmButtonColor: "#f7931a",
      //   cancelButtonColor: "#1C1C1C",
      // });
      console.log(err.response?.data?.detail || "Failed to fetch location details.");
    } finally {
      setLoading(false);
    }
  };

  const fetchEventsDetails = async ( sport_id, sale_id, player_id, filterData ) => {
    const token = localStorage.getItem("accessToken");
    
    if(!token){
      navigate("/login");
      return;
    }
    let p_id =``;
    if(player_id){
      p_id= `&player_id=${player_id}`

    }else{
      p_id =``
    }

    let paramsss = {}

    if (filterData){
      paramsss = filterData

    }else{
      paramsss = { timezone: time_Zone, }
    }
    
    try {
      const response = await axiosInstance.get(`/scheduler/get_sport_events/?sport_id=${sport_id}&sale_id=${sale_id}${p_id}`, {
        headers: { Authorization: `Bearer ${token}` },
        params: paramsss
      });
      
      return response.data;

    } catch (err) {
      // Swal.fire({
      //   icon: "error",
      //   title: "Error",
      //   text: err.response?.data?.detail || "Failed to fetch parent details.",
      //   confirmButtonColor: "#f7931a",
      //   cancelButtonColor: "#1C1C1C",
      // });
      console.log(err.response?.data?.detail || "Failed to fetch parent details.");

    } finally {
      setLoading(false);
    }
  };


  const checkEventsBooking = async (data) => {
    const token = localStorage.getItem("accessToken");
    if(!token){
      navigate("/login");
      return;
    }
    setConfirmData(null);
    try {
      const response = await axiosInstance.post("/scheduler/check-booking/", data, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
              
              timezone: time_Zone,   
            }
      });

        // ➤ POSSIBLE = TRUE
        if (response?.data.possible) {
            const confirmRes = await confirmEventsBooking(data);
            if(confirmRes){
              return { success: true, data: confirmRes };
            }
        }

        // // ➤ POSSIBLE = FALSE
        // return {
        //     success: false,
        //     data: response.data  
        // };
      

    } catch (err) {
      Swal.fire({
          icon: "error",
          title: "Error",
          text: err.response.data.message,
          confirmButtonColor: "#f7931a",
          cancelButtonColor: "#1C1C1C",
      });
    } finally {
      setLoading(false);
    }
  };

  const confirmEventsBooking = async (data) => {
    const token = localStorage.getItem("accessToken");
    if(!token){
      navigate("/login");
      return;
    }
    
    try {
      const response = await axiosInstance.post("/scheduler/confirm-booking/", data, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
              
              timezone: time_Zone,   
            }
      });
      
      return response.data;

    } catch (err) {
      
      Swal.fire({
          icon: "error",
          title: "Error",
          text: err.response.data.errors[0].message,
          confirmButtonColor: "#f7931a",
          cancelButtonColor: "#1C1C1C",
      });
      return;
    } finally {
      setLoading(false);
    }
  };


  return (
    <BookSessionContext.Provider
      value={{
        loading,
        fetchEventsDetails,
        checkEventsBooking,
        confirmEventsBooking,
        confirmData,
        fetchLocationData
      }}
    >
      {loading && (
       <Loader/>
      )}
      {children}
    </BookSessionContext.Provider>
  );
};
